import { render, staticRenderFns } from "./AssignedVisitPointList.vue?vue&type=template&id=386e65a6&scoped=true"
import script from "./AssignedVisitPointList.vue?vue&type=script&lang=js"
export * from "./AssignedVisitPointList.vue?vue&type=script&lang=js"
import style0 from "./AssignedVisitPointList.vue?vue&type=style&index=0&id=386e65a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e65a6",
  null
  
)

export default component.exports